import { render, staticRenderFns } from "./quality-pill.vue?vue&type=template&id=27b6c0c4&scoped=true"
import script from "./quality-pill.vue?vue&type=script&lang=js"
export * from "./quality-pill.vue?vue&type=script&lang=js"
import style0 from "./quality-pill.vue?vue&type=style&index=0&id=27b6c0c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b6c0c4",
  null
  
)

export default component.exports